module.exports = __webpack_public_path__ + "launcher-37f9d767c4a9861c9c2b.svg";